/**
 * Funcionalidades de "Dados do Setor" (dados públicos da ANS): o `PermissaoService` as libera a
 * qualquer autenticado, sem consultar a lista do back-end. Elas correspondem às rotas em
 * `dados-setor` (IDSS do Setor e Terminologia) e ao menu "Dados Setoriais" do topbar
 * (`TOPBAR_MENU`).
 *
 * IMPORTANTE: mantenha sincronizado com os `featureCode` das rotas em
 * `dados-setor-routing.module.ts`.
 */
export const FUNCIONALIDADES_SETOR_CODES = [
  // IDSS do Setor
  'IDSS_SETOR.RESULTADOS_OPERADORA',
  'IDSS_SETOR.BENCHMARKING_IDSS',
  'IDSS_SETOR.RANKING_IDSS',
  // Terminologia
  'TERMINOLOGIA.CAMPOS_MONITORAMENTO_TISS',
  'TERMINOLOGIA.CBO',
  'TERMINOLOGIA.TERMOS_DOMINIOS',
  'TERMINOLOGIA.TABELAS',
  'TERMINOLOGIA.MOTIVOS_GLOSA',
  'TERMINOLOGIA.CAMPOS_CRITICAS_ANS',
  'TERMINOLOGIA.ITENS_PROCEDIMENTOS_TUSS',
] as const;
